import React from 'react';
import TrafficLandingTemplate, { LandingPageConfig } from './TrafficLandingTemplate';
import { Activity, BarChart3, Globe } from 'lucide-react';

const config: LandingPageConfig = {
    slug: 'vi/social-traffic-la-gi',
    titleTag: 'What is Social Traffic | Premium | Traffic Creator',
    metaDescription: 'What is Social Traffic - residential IP traffic, GA4 verified. 190+ countries.',
    keywords: 'What is Social Traffic, Social Traffic, Website Traffic, Residential Traffic',
    primaryKeyword: 'What is Social Traffic',
    secondaryKeyword: 'Social Traffic',
    reviewCount: '584',
    ratingValue: '4.9',

    h1: 'What is Social Traffic — Premium Residential Traffic',
    subheadline: 'Tất cả những gì bạn cần để tăng hiệu suất website và thứ hạng tìm kiếm.',

    problemH2: 'What is Social Traffic — Mạng IP Residential',
    problemText: 'Mỗi lượt truy cập đến từ địa chỉ IP residential thực, hoàn toàn không thể phát hiện bởi nền tảng phân tích.',
    solutionPoints: [
        'IP residential thực từ hơn 190 quốc gia',
        'Phiên trình duyệt đầy đủ với hành vi tự nhiên',
        'Mỗi phiên hiển thị trong Google Analytics 4',
        'An toàn cho SEO — không phát hiện bot'
    ],

    featuresH2: 'What is Social Traffic — Traffic Xác Minh GA4',
    features: [
        {
            icon: <Activity />,
            title: 'Mạng IP Residential',
            description: 'Mỗi lượt truy cập đến từ địa chỉ IP residential thực, hoàn toàn không thể phát hiện bởi nền tảng phân tích.'
        },
        {
            icon: <BarChart3 />,
            title: 'Traffic Xác Minh GA4',
            description: 'Xem mỗi phiên theo thời gian thực trong bảng điều khiển Google Analytics 4 với thống kê chính xác.'
        },
        {
            icon: <Globe />,
            title: 'Geo-Targeting Chính Xác',
            description: 'Nhắm mục tiêu khách truy cập từ các quốc gia, khu vực và thành phố cụ thể để đạt hiệu quả tối đa.'
        }
    ],

    testimonialsH2: 'What is Social Traffic — +300% Traffic',
    testimonials: [
        {
            name: 'Linh M.',
            role: 'Giám đốc Marketing',
            result: '+300% Traffic',
            text: 'Traffic Creator cung cấp chính xác những gì chúng tôi cần. Traffic chất lượng cao và hiển thị đáng tin cậy trong GA4.',
            seed: 'whativi1'
        },
        {
            name: 'Tuấn A.',
            role: 'Doanh nhân Online',
            result: 'Bounce Rate Thấp Hơn',
            text: 'Sau khi chuyển đổi, chúng tôi nhận thấy sự khác biệt ngay lập tức. Khách truy cập thực với tương tác thực.',
            seed: 'whativi2'
        },
        {
            name: 'Long R.',
            role: 'Chủ Agency',
            result: 'Xếp Hạng Tốt Hơn',
            text: 'Traffic từ IP residential hoạt động tuyệt vời. Các chỉ số SEO của chúng tôi đã cải thiện đáng kể.',
            seed: 'whativi3'
        }
    ],

    ctaH2: 'Dùng Thử Miễn Phí — What is Social Traffic',

    faqs: [
        {
            question: 'Hệ thống hoạt động như thế nào?',
            answer: 'Hệ thống của chúng tôi điều hướng khách truy cập thực qua IP residential từ hơn 190 quốc gia, mô phỏng hành vi người dùng tự nhiên.'
        },
        {
            question: 'Có an toàn cho website của tôi không?',
            answer: 'Có, hoàn toàn an toàn. Traffic của chúng tôi đến từ IP residential thực và không thể phát hiện bởi Google và nền tảng phân tích.'
        },
        {
            question: 'Traffic có hiển thị trong Google Analytics không?',
            answer: 'Chắc chắn. Mỗi lượt truy cập được ghi nhận đầy đủ trong GA4 với thời gian phiên, trang mỗi lượt truy cập và dữ liệu địa lý.'
        },
        {
            question: 'Giao hàng bắt đầu nhanh như thế nào?',
            answer: 'Trong vòng 5 phút sau khi cấu hình chiến dịch, khách truy cập đầu tiên sẽ bắt đầu đến website của bạn.'
        },
        {
            question: 'Có dùng thử miễn phí không?',
            answer: 'Có! Đăng ký và bắt đầu chiến dịch đầu tiên miễn phí. Không cần thẻ tín dụng.'
        }
    ],

    relatedLinks: [
        { label: 'What is Social Traffic', to: '/vi/mua-traffic-website' },
        { label: 'What is Social Traffic', to: '/vi/traffic-bot' },
        { label: 'What is Social Traffic', to: '/vi/seo-traffic-booster' }
    ],

    productName: 'What is Social Traffic — Premium Residential Traffic',
    productDescription: 'What is Social Traffic - residential IP traffic, GA4 verified. 190+ countries.',

    translations: {
        navFeatures: 'Tính năng',
        navPricing: 'Bảng giá',
        navFaq: 'FAQ',
        navLogin: 'Đăng nhập',
        heroBadge: 'Traffic Chất Lượng Cao',
        heroCtaPrimary: 'Dùng Thử Miễn Phí',
        heroCtaSecondary: 'Xem Bảng Giá',
        heroTrust: 'Được hơn 10.000 người dùng tin tưởng',
        heroMicrocopy: 'Không cần thẻ tín dụng. An toàn 100% và được xác minh Analytics.',
        heroLiveLabel: 'Trực tiếp',
        heroTrafficIncrease: 'Tăng Traffic',
        heroActiveLabel: 'Đang hoạt động',
        heroVisitorsServed: 'Lượt Truy Cập Đã Phục Vụ',
        socialProofLabel: 'Được tin tưởng bởi:',
        problemWithout: 'Không có',
        problemWith: 'Với',
        problemBullets: [
            'Traffic tự nhiên thấp hạn chế sự phát triển',
            'Kết quả tìm kiếm kém ảnh hưởng đến chuyển đổi',
            'Đối thủ thống trị từ khóa của bạn',
            'Tỷ lệ thoát cao gây hại cho SEO',
        ],
        statsCampaigns: 'Chiến dịch hoạt động hàng ngày',
        statsCountries: 'Quốc gia',
        statsUptime: 'Uptime',
        statsSupport: 'Hỗ trợ',
        featuresSubtitle: 'Tất cả những gì bạn cần để tăng hiệu suất website và thứ hạng tìm kiếm.',
        howItWorksH2: '3 Bước Đơn Giản',
        howItWorksSteps: [
            { title: 'Cấu Hình Chiến Dịch', desc: 'Chọn quốc gia, thiết bị và cài đặt hành vi trong vài phút.' },
            { title: 'Khởi Động Mạng Lưới', desc: 'Ngồi lại và để nền tảng của chúng tôi điều hướng khách truy cập thực đến URL của bạn.' },
            { title: 'Phân Tích Kết Quả', desc: 'Xem các chỉ số của bạn cải thiện trong Google Analytics 4.' },
        ],
        pricingH2: 'Bảng Giá Minh Bạch',
        pricingSubtitle: 'Mua một lần. Không đăng ký. Credits không hết hạn.',
        pricingMostPopular: 'Phổ biến nhất',
        pricingVisitors: 'lượt truy cập',
        pricingGetStarted: 'Bắt Đầu Ngay',
        pricingGuarantee: 'Bảo đảm hoàn tiền 30 ngày',
        pricingDelivery: 'Giao hàng tức thì (~5 phút)',
        pricingCountries: '190+ Quốc gia',
        faqH2: 'Câu Hỏi Thường Gặp',
        ctaSubtitle: 'Tham gia cùng hơn 10.000 khách hàng và tăng traffic website của bạn ngay hôm nay.',
        ctaButtonPrimary: 'Bắt Đầu Miễn Phí',
        ctaButtonSecondary: 'Xem Bảng Giá',
        ctaMicrocopy: 'Không cần thẻ tín dụng. An toàn 100% và được xác minh Analytics.',
        footerDescription: 'giải pháp cho chuyên gia SEO và agency kỹ thuật số toàn cầu.',
        footerRelatedServices: 'Dịch Vụ Liên Quan',
        footerCompany: 'Công ty',
        footerAbout: 'Về Chúng Tôi',
        footerBlog: 'Blog',
        footerHelpCenter: 'Trung Tâm Trợ Giúp',
        footerPrivacy: 'Chính Sách Bảo Mật',
        footerImpressum: 'Impressum',
        footerStatus: 'Tất Cả Hệ Thống Hoạt Động',
        footerBuyTraffic: 'Mua Traffic Website',
    }
};

const ViWhatIsSocialTraffic: React.FC = () => {
    return <TrafficLandingTemplate config={config} />;
};

export default ViWhatIsSocialTraffic;
